import { combineReducers } from "@reduxjs/toolkit";
import {
  checkEmailReducer,
  codeValidatorReducer,
  confirmValidatorReducer,
  externalLoginReducer,
  forgotPasswordReducer,
  loginReducer,
  registerReducer,
  resetPasswordReducer,
} from "./slices";

const authReducer = combineReducers({
  emailChecker: checkEmailReducer,
  codeValidator: codeValidatorReducer,
  confirmValidator: confirmValidatorReducer,
  register: registerReducer,
  login: loginReducer,
  externalLogin: externalLoginReducer,
  forgotPassword: forgotPasswordReducer,
  resetPassword: resetPasswordReducer,
});

export default authReducer;
